function upsertMeta(attr: "name" | "property", key: string, content: string): void {
  if (!content) {
    return;
  }

  let element = document.querySelector(`meta[${attr}="${key}"]`);
  if (!element) {
    element = document.createElement("meta");
    element.setAttribute(attr, key);
    document.head.appendChild(element);
  }
  element.setAttribute("content", content);
}

/** Runtime OG/Twitter meta (browsers; WhatsApp uses static index.html from sync script). */
export function updateDocumentSocialMeta(params: {
  title: string;
  description?: string;
  imageUrl?: string;
  siteUrl?: string;
}): void {
  if (typeof document === "undefined") {
    return;
  }

  document.title = params.title;

  if (params.description) {
    upsertMeta("name", "description", params.description);
    upsertMeta("property", "og:description", params.description);
    upsertMeta("name", "twitter:description", params.description);
  }

  upsertMeta("property", "og:title", params.title);
  upsertMeta("name", "twitter:title", params.title);
  upsertMeta("property", "og:type", "website");
  upsertMeta("name", "twitter:card", "summary_large_image");

  if (params.imageUrl) {
    upsertMeta("property", "og:image", params.imageUrl);
    upsertMeta("name", "twitter:image", params.imageUrl);
  }

  if (params.siteUrl) {
    upsertMeta("property", "og:url", params.siteUrl);
  }
}
